module.exports = __webpack_public_path__ + "img/50m2.a6d7b209.jpg";